import type { TFileUploadEntry } from '@crehana/compass.web/file-upload';

import type { NotificationHubTemplateAttachmentInput } from '@/__generated__/graphql/types';

export const toAttachmentInput = (
  entries: TFileUploadEntry[],
): NotificationHubTemplateAttachmentInput[] =>
  entries.flatMap(entry =>
    entry.status === 'success' && entry.uploadedFile
      ? [
          {
            file_id: entry.uploadedFile.id,
            name: entry.uploadedFile.name,
            size: entry.uploadedFile.size,
            content_type: entry.uploadedFile.content_type,
          },
        ]
      : [],
  );
